////////////////////////////////////////////
// NAV ICONS — STROKE GLYPHS FOR THE NAV LINKS
////////////////////////////////////////////
//
// className OVERRIDES THE DEFAULT 15px SIZE — THE MOBILE BOTTOM BAR RENDERS
// THE SAME GLYPHS LARGER FOR TOUCH.
import type { SVGProps } from "react";

export interface NavIconProps {
  className?: string;
}

function iconProps(className?: string): SVGProps<SVGSVGElement> {

  return {
    className: className ?? "w-[15px] h-[15px] flex-none",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
}

export const HomeIcon = ({ className }: NavIconProps) => (
  <svg {...iconProps(className)}><path d="M2.7 7.6 8 3.1l5.3 4.5" /><path d="M4.1 7v6h7.8V7" /></svg>
);
export const CreateIcon = ({ className }: NavIconProps) => (
  <svg {...iconProps(className)}><circle cx="8" cy="8" r="6.3" /><path d="M8 5.4v5.2M5.4 8h5.2" /></svg>
);
export const PadIcon = ({ className }: NavIconProps) => (
  <svg {...iconProps(className)}><rect x="2.6" y="2.6" width="4.6" height="4.6" rx="1.2" /><rect x="8.8" y="2.6" width="4.6" height="4.6" rx="1.2" /><rect x="2.6" y="8.8" width="4.6" height="4.6" rx="1.2" /><rect x="8.8" y="8.8" width="4.6" height="4.6" rx="1.2" /></svg>
);
export const HowIcon = ({ className }: NavIconProps) => (
  <svg {...iconProps(className)}><circle cx="8" cy="8" r="6.3" /><path d="M8 7.3v3.4M8 5.2h.01" /></svg>
);
export const AdminIcon = ({ className }: NavIconProps) => (
  <svg {...iconProps(className)}><path d="M2.6 11.2a5.4 5.4 0 0 1 10.8 0" /><path d="M8 11.2 10.9 8" /><path d="M8 3.2v1M3.4 5.1l.7.7M12.6 5.1l-.7.7" /></svg>
);
